import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { FaCalendarAlt, FaUser } from "react-icons/fa";
import { RouteComponentProps } from "react-router";
import Button from "../../components/Form/Button";
import Input from "../../components/Form/Input";
import ErroConsulta from "../../components/ErroConsulta";
import Loading from "../../components/Loading";
import PageHeader from "../../components/PageHeader";
import SubTitle from "../../components/SubTitle";
import { useAuth } from "../../hooks/auth";
import { api } from "../../services/api";
import { semDadosNoProtheus } from "../../utils/consulta";
import { b64toBlob } from "../../utils/base62";
import { anos, meses } from "../../utils/datas";
import { Filters, InputGroup } from "../BillsToPay/styles";

import { Container } from "./styles";

interface ExtratoValeCapulProps {}

function ExtratoValeCapul({}: RouteComponentProps<ExtratoValeCapulProps>) {
  const { user } = useAuth();
  const { control, handleSubmit } = useForm();
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  const [erro, setErro] = useState(false);
  // Ultimo periodo pedido, para o "Tentar novamente" repetir a mesma geracao
  const [ultimoAnomes, setUltimoAnomes] = useState("");

  async function getPdf(anomes: string) {
    setUltimoAnomes(anomes);
    setLoading(true);
    setNoData(false);
    setErro(false);
    let newTab = window.open();
    newTab.document.write("Gerando o PDF do extrato vale Capul, aguarde alguns instantes...");
    newTab.document.title = "Gerando PDF...";
    try {
      const res = await api.get<any>("extratoVale", {
        params: {
          CODCLIENTE: user.matricula,
          ANOMES: anomes,
        },
      });
      if (!res.data.pdf) throw new Error("Erro ao requisitar pdf");
      const blob = b64toBlob(res.data.pdf, "application/pdf");
      const url = URL.createObjectURL(blob);
      newTab.location.href = url;
    } catch (err) {
      newTab.close();
      // Resposta sem PDF ou 400 do Protheus = sem registros; erro HTTP/rede
      // (link com a Capul, timeout, 5xx) = falha de conexao
      if (err.isAxiosError && !semDadosNoProtheus(err)) {
        setErro(true);
      } else {
        setNoData(true);
      }
    } finally {
      setLoading(false);
    }
  }

  function submitForm(form) {
    if (form.ano && form.mes) {
      getPdf(form.ano + form.mes);
    }
  }

  return (
    <Container>
      <PageHeader title="Extrato Vale Capul" />

      <SubTitle text="Informe o período:" icon={FaCalendarAlt} />
      <SubTitle
        text="O relatório é gerado em PDF e aberto em uma nova aba. Para períodos longos, a geração pode levar até 1 minuto."
        sub
      />
      <Filters>
        <InputGroup>
          <Input
            control={control}
            type="select"
            values={anos}
            name="ano"
            placeholder="Ano"
          />
        </InputGroup>
        <InputGroup>
          <Input
            control={control}
            type="select"
            values={meses}
            name="mes"
            placeholder="Mês"
          />
        </InputGroup>
        <InputGroup>
          <Button disabled={loading} onClick={handleSubmit(submitForm)}>
            {loading ? <Loading /> : "CONSULTAR"}
          </Button>
        </InputGroup>
      </Filters>
      {erro && (
        <ErroConsulta
          mensagem="Não foi possível gerar o extrato do Vale Capul no momento. Tente novamente em instantes."
          onTentarNovamente={() => getPdf(ultimoAnomes)}
        />
      )}
      {noData && <SubTitle icon={FaUser} text="Não foram encontrados registros com os parâmetros informados." />}
    </Container>
  );
}

export default ExtratoValeCapul;
